import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import type {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
  StripeElementStyle,
} from '@stripe/stripe-js';
import { Stack, Columns, Column } from 'braid-design-system';
import { useState } from 'react';

import { CheckoutFormField } from './components/CheckoutFormField/CheckoutFormField';

import * as styles from './CheckoutForm.css';

export const CheckoutForm = () => {
  const [cardNumberEvent, setCardNumberEvent] =
    useState<StripeCardNumberElementChangeEvent | null>(null);
  const [cardCvcEvent, setCardCvcEvent] =
    useState<StripeCardCvcElementChangeEvent | null>(null);
  const [cardExpiryEvent, setCardExpiryEvent] =
    useState<StripeCardExpiryElementChangeEvent | null>(null);

  return (
    <Stack space="medium">
      <CheckoutFormField
        id="cardNumber"
        label="Card number"
        error={cardNumberEvent?.error?.message}
      >
        <CardNumberElement
          className={styles.stripeCardNumberInput}
          onChange={setCardNumberEvent}
          options={{ style: stripeInputStyles }}
        />
      </CheckoutFormField>

      <Columns space="medium" collapseBelow="desktop">
        <Column>
          <CheckoutFormField
            id="cvc"
            label="CVC"
            error={cardCvcEvent?.error?.message}
          >
            <CardCvcElement
              className={styles.stripeCardNumberInput}
              onChange={setCardCvcEvent}
              options={{ style: stripeInputStyles }}
            />
          </CheckoutFormField>
        </Column>

        <Column>
          <CheckoutFormField
            id="cardExpiry"
            label="Card expiry"
            error={cardExpiryEvent?.error?.message}
          >
            <CardExpiryElement
              className={styles.stripeCardNumberInput}
              onChange={setCardExpiryEvent}
              options={{ style: stripeInputStyles }}
            />
          </CheckoutFormField>
        </Column>
      </Columns>
    </Stack>
  );
};

// Copied from Braid which they don't publically expose
const braidCopiedStyles = {
  textSizeStandardTabletFontSize: '16px',
  textSizeStandardTabletLineHeight: '24.528px',
  fontFamily: 'SeekSans, "SeekSans Fallback", Arial, Tahoma, sans-serif',
  secondaryColour: '#2E3849',
};

const stripeInputStyles: StripeElementStyle = {
  base: {
    fontSize: braidCopiedStyles.textSizeStandardTabletFontSize,
    lineHeight: braidCopiedStyles.textSizeStandardTabletLineHeight,
    fontFamily: braidCopiedStyles.fontFamily,
    color: braidCopiedStyles.secondaryColour,
  },
  invalid: {
    color: braidCopiedStyles.secondaryColour,
  },
};
